/*
* Simple for LitePicker.js
* */
function JSApogodinCalendar(params)
{
    new Litepicker({
        element: document.getElementById(params.INPUT_NAME_MIN + '_datepicker'),
        parentEl: document.getElementById(params.INPUT_NAME_MIN + '_datepicker_container'),
        singleMode: false,
        inlineMode: true,
        lang: 'russian',
        format: "DD.MM.YYYY",
        startDate: params.INPUT_NAME_MIN_HTML_VALUE ? params.INPUT_NAME_MIN_HTML_VALUE : null,
        endDate: params.INPUT_NAME_MAX_HTML_VALUE ? params.INPUT_NAME_MAX_HTML_VALUE : null,
        tooltipText: {
            one: 'night',
            other: 'nights'
        },

        tooltipNumber: (totalDays) => {
            return totalDays - 1;
        },
        setup: (picker) => {
            picker.on('selected', (date1, date2) => {
                if (!!onStartLitepickerTimer){
                    clearTimeout(onStartLitepickerTimer);
                }
                let minControl = document.getElementById(params.INPUT_NAME_MIN);
                let maxControl = document.getElementById(params.INPUT_NAME_MAX);
                minControl.value = document.getElementById(params.INPUT_NAME_MIN+ '_datepicker').value.split(' - ')[0] + " 00:00:01";
                maxControl.value = document.getElementById(params.INPUT_NAME_MIN+ '_datepicker').value.split(' - ')[1] + " 23:59:59";
                // change only min, because use only range
                minControl.dispatchEvent(new Event('change'));
            });
            picker.on('before:click', (target) => {
                if (!target.classList.contains("is-end-date")){
                    onStartLitepicker(params.INPUT_NAME_MIN, params.INPUT_NAME_MAX, target);
                }
            });
        },
    })
}

window.onStartLitepickerTimer = null;
window.onStartLitepicker = function (minId, maxId, target){

    if (!!onStartLitepickerTimer){
        clearTimeout(onStartLitepickerTimer);
    }
    onStartLitepickerTimer = setTimeout(function (){
        let minControl = document.getElementById(minId);
        let maxControl = document.getElementById(maxId);
        if (!target.classList.contains("is-end-date")){
            let timestamp = target.dataset.time * 1;
            var newDate = new Date(timestamp);
            let stringDate = newDate.toLocaleString().split(',');
            minControl.value = stringDate[0] + " 00:00:01";
            maxControl.value = stringDate[0] + " 23:59:59";
            minControl.dispatchEvent(new Event('change'));

        }
    }, 2500)

}